export default {
    namespaced: true,
    state: {
        variant: null,
        message: null,
        show: false,
        alertKey: 0,
    },
    mutations: {
        setAlert(state, { variant, message }) {
            state.variant = variant;
            state.message = message;
            state.show = true;
            state.alertKey++;
        },

        setDangerAlert(state, message) {
            state.variant = 'danger';
            state.message = message;
            state.show = true;
            state.alertKey++;
        },

        setWarningAlert(state, message) {
            state.variant = 'warning';
            state.message = message;
            state.show = true;
            state.alertKey++;
        },

        setInfoAlert(state, message) {
            state.variant = 'info';
            state.message = message;
            state.show = true;
            state.alertKey++;
        },

        setSuccessAlert(state, message) {
            state.variant = 'success';
            state.message = message;
            state.show = true;
            state.alertKey++;
        },

        clearAlert(state) {
            state.variant = null;
            state.message = null;
            state.show = false;
            state.alertKey++;
        }
    },
    getters: {
        getAlert(state) {
            return state;
        },

        getType(state) {
            return state.variant;
        },

        getMessage(state) {
            return state.message;
        },

        getShow(state) {
            return state.show;
        },

        getKey(state) {
            return state.alertKey;
        },
    }
}
